"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const SpotWorkerSlot_vue_1 = __importDefault(require("./SpotWorkerSlot.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'SummaryTableSpotworkerCell',
    props: {
        spotShifts: {}
    },
    emits: ["selected-shift"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emits = __emit;
        function handleShiftSelect(shiftId) {
            emits("selected-shift", shiftId);
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(_ctx.spotShifts, (s) => {
                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                    key: s.id
                }, [
                    (0, vue_2.createVNode)(SpotWorkerSlot_vue_1.default, {
                        shift: s,
                        onSelectedShift: handleShiftSelect
                    }, null, 8 /* PROPS */, ["shift"])
                ]));
            }), 128 /* KEYED_FRAGMENT */));
        };
    }
});
